import { Flex } from 'antd';
import { AttachmentsInput, IF } from 'common';
import { AddAttachmentIcon } from 'common/all-icons/custom-icons';
import { useRef } from 'react';
import { onAddFiles, uploadFile, validateAttachmentFiles } from 'utils/attachment-util';

const FileDragDrop = ({
  files = [],
  setFiles = () => {},
  title = 'Click or drag here to upload file',
  description = 'Drag & drop images here, or click to select files',
  acceptTypes = 'image/*,application/pdf',
  allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'],
  maxSizeInBytes = 15 * 1024 * 1024,
  getUrlApi = null,
  attachmentKey = '',
  height = '100%',
  titleClassName = 'body-16-semibold',
  descriptionClassName = 'body-12-medium',
  descriptionStyle = {},
  gap = 10,
  renderCustomUploadButton,
  style = {},
  makeBlob = true,
  multiple = true,
  typeSlug = '',
  capture,
  attachmentIcon = <AddAttachmentIcon />,
  labelSlug,
  labelSourceClass,
}) => {
  const fileInputRef = useRef(null);

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragSuccess = async (validFiles) => {
    if (!validFiles?.length) return;

    const updatedFiles = onAddFiles({ files, setFiles, newFiles: validFiles })?.updatedFiles || [];
    updatedFiles?.forEach((item) => {
      uploadFile({
        item,
        attachmentKey,
        typeSlug,
        labelSlug,
        labelSourceClass,
        getUrlApi,
        files: updatedFiles,
        setFiles,
        makeBlob: makeBlob,
        isSvg: item?.file?.type === 'image/svg+xml',
      });
    });
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const droppedFiles = event.dataTransfer.files;
    validateAttachmentFiles({
      newFiles: droppedFiles,
      onSuccess: handleDragSuccess,
      allowedTypes,
      maxSizeInBytes,
    });
  };

  return (
    <>
      <AttachmentsInput
        files={files}
        fileInputRef={fileInputRef}
        attachmentKey={attachmentKey}
        multiple={multiple}
        getUrlApi={getUrlApi}
        setFiles={setFiles}
        acceptTypes={acceptTypes}
        allowedTypes={allowedTypes}
        maxSizeInBytes={maxSizeInBytes}
        makeBlob={makeBlob}
        capture={capture}
        labelSlug={labelSlug}
        labelSourceClass={labelSourceClass}
      />
      <Flex
        justify="center"
        align="center"
        onClick={() => fileInputRef.current?.click()}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        role="button"
        style={{
          height: height,
          ...style,
        }}
      >
        <Flex vertical justify="center" align="center" gap={gap}>
          <IF condition={!renderCustomUploadButton}>
            <div className="primary-text">{attachmentIcon}</div>
          </IF>
          <Flex vertical justify="center" align="center" gap={4}>
            <div className={titleClassName}>{title}</div>
            <div style={descriptionStyle} className={descriptionClassName}>
              {description}
            </div>
          </Flex>
          {renderCustomUploadButton && renderCustomUploadButton({})}
        </Flex>
      </Flex>
    </>
  );
};

export default FileDragDrop;
